var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"color":"error","icon":"info","dismissible":"","value":true},on:{"input":_vm.onClose}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }